// 第3弾: Instagram 投稿の自動検知（写真に @stoq_kitchen をタグ付けした投稿）の状態・一覧と「今すぐ確認」。
// 精算・連携の検知カード・素材庫の「検知した投稿」・ダッシュボードの要対応で共用する。
import { useCallback, useEffect, useState } from "react";
import { fetchGfIgDetectedMedia, fetchGfIgDetectStatus, postGfIgDetectRun } from "../../api/giftingClient";
import type { GfIgDetectedMedia, GfIgDetectResult, GfIgDetectStatus, GfIgMediaFilter, Loadable } from "../../types/gifting";
import { errMsg } from "./gfUtil";

export function useGfIgDetectStatus(reloadKey: unknown) {
  const [status, setStatus] = useState<Loadable<GfIgDetectStatus>>({ status: "loading" });
  const [running, setRunning] = useState(false);

  const load = useCallback(async () => {
    try {
      setStatus({ status: "ok", data: await fetchGfIgDetectStatus() });
    } catch (e) {
      setStatus({ status: "error", message: errMsg(e) });
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load, reloadKey]);

  /** 確認を実行して結果を返す（失敗時は例外をそのまま投げる。呼び出し側でトースト） */
  const run = useCallback(async (): Promise<GfIgDetectResult> => {
    setRunning(true);
    try {
      const r = await postGfIgDetectRun();
      await load();
      return r;
    } finally {
      setRunning(false);
    }
  }, [load]);

  return { status, running, run, reload: load };
}

/** 検知した投稿の一覧（filter の既定は未紐づけ）。reloadKey が変わるたびに取り直す */
export function useGfIgDetectedMedia(filter: GfIgMediaFilter, reloadKey: unknown) {
  const [media, setMedia] = useState<Loadable<GfIgDetectedMedia[]>>({ status: "loading" });

  const load = useCallback(async () => {
    try {
      setMedia({ status: "ok", data: await fetchGfIgDetectedMedia(filter) });
    } catch (e) {
      setMedia({ status: "error", message: errMsg(e) });
    }
  }, [filter]);

  useEffect(() => {
    void load();
  }, [load, reloadKey]);

  return { media, reload: load };
}
